module.exports = __webpack_public_path__ + "img/weftComparison.66a09bd7.jpeg";